import { setPlatformDep } from 'common/helpers/platformDeps';

setPlatformDep('localCache', () => require('lscache'))
setPlatformDep('lscache', () => require('lscache'))

